import { collection, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

import { ATOMS } from "../../recoil/atom";
import { IBakusVersion } from "../../types/versions";
import { createSnackBarContent } from "../global/useSnackBar";
import { fireDatabase } from "../../config/firebase";
import { needRequestCollections } from "../../constants/access";
import { sortByVersion } from "../../utils/versions";
import useNeedRequestVisibilityHelper from "../data/useNeedRequestVisibilityHelper";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

const collectionRequired = [needRequestCollections.VERSIONS];

const useBakusVersionsList = () => {
  const { t } = useTranslation(["snackbar"]);
  const popSnackbar = useSetAtom(ATOMS.SNACKBAR);

  const setBakusVersionsList = useSetAtom(ATOMS.BAKUS_VERSIONS);

  const [unSubscribe, setUnSubscribe] = useState<(() => void) | null>(null);

  const canLoadData = useNeedRequestVisibilityHelper(() => {
    unSubscribe && unSubscribe();
  }, collectionRequired);

  // Bakus versions list
  useEffect(() => {
    if (canLoadData) {
      const unsub = onSnapshot(
        collection(fireDatabase, "versions", "bakus", "bakus_versions"),
        (snap) => {
          const dataBakusVersions: IBakusVersion[] = [];
          snap.docs.forEach((doc) => {
            const data = doc.data();
            if (data && !data.archived) {
              dataBakusVersions.push(data as IBakusVersion);
            }
          });
          setBakusVersionsList(dataBakusVersions.sort(sortByVersion("desc")));
        },
        (err) => {
          console.error(err);
          popSnackbar(
            createSnackBarContent({
              content: t("snackbar:request_bakus_versions_error"),
              severity: "error",
            }),
          );
          setBakusVersionsList([]);
        },
      );

      setUnSubscribe(() => unsub);
      return () => unsub();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canLoadData]);

  return null;
};

export default useBakusVersionsList;
